module.exports = __webpack_public_path__ + "img/experiment-no-list.a0467855.png";